import { render, staticRenderFns } from "./ErrorTips.vue?vue&type=template&id=6d61615e&"
import script from "./ErrorTips.vue?vue&type=script&lang=js&"
export * from "./ErrorTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d61615e')) {
      api.createRecord('6d61615e', component.options)
    } else {
      api.reload('6d61615e', component.options)
    }
    module.hot.accept("./ErrorTips.vue?vue&type=template&id=6d61615e&", function () {
      api.rerender('6d61615e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/ErrorTips.vue"
export default component.exports